var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuccessIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-67 -71) translate(67 71)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "#F8F8FD",
    rx: 9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#050849",
    d: "M3 1.5C3 2.328 2.328 3 1.5 3 .67 3 0 2.328 0 1.5S.671 0 1.5 0C2.328 0 3 .672 3 1.5zM20 1.5c0 .828-.672 1.5-1.5 1.5-.829 0-1.5-.672-1.5-1.5S17.671 0 18.5 0c.828 0 1.5.672 1.5 1.5z",
    transform: "translate(9 16)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#050849",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M7 9c0 1.657 1.343 3 3 3s3-1.343 3-3",
    transform: "translate(9 16)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.3d961f5a.svg";
export { ForwardRef as ReactComponent };